// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__oX97k","title":"FrontImage_title__3vh0i"};